import {
  ExReceptionDraftsService,
  type InitExReceptionDraftDTO,
} from "../../../api/exReceptions"
import { useCreateWarehouseDocumentDraft } from "../shared/useCreateWarehouseDocumentDraft"

export function useCreatePZ() {
  const { createDocument, isCreating, isResolvingWarehouses, canCreate } =
    useCreateWarehouseDocumentDraft({
      mutationKey: ["wms", "ex-receptions"] as const,
      documentCode: "PZ",
      blockedWarehouseDescription:
        "Magazyn źródłowy z kontekstu jest obecnie zablokowany przez aktywną inwentaryzację.",
      missingWarehouseDescription:
        "Brak aktywnego magazynu dostępnego do utworzenia dokumentu PZ.",
      createDraftRequest: (payload: InitExReceptionDraftDTO) =>
        ExReceptionDraftsService.initExReceptionDraft(payload),
      buildPayload: (warehouseId: string) => ({
        warehouse_id: warehouseId,
      }),
      getSuccessNavigation: (draft) => ({
        to: "/WMS/documents/ex-receptions/$exReception",
        params: { exReception: draft.id },
        search: { tab: "general", edit: 1 },
      }),
    })

  return {
    createPZ: (preferredWarehouseId?: string) =>
      createDocument({ preferredWarehouseId }),
    isCreating,
    isResolvingWarehouses,
    canCreate,
  }
}
